import mockProvider from './mockProvider'

const mocks = {
  mockProvider
}

export default mocks
